const breakpoints = {
  base: "0em",
  xsm: "23em", // 368px
  xsm2: "400px",
  sm: "30em", // 480px
  smm: "600px",
  md: "48em", // 768px
  mxd: "48.01em", // 769px
  lg: "992px", // 992px
  lg2: "64em", // 1024px
  xl: "80em", // 1280px
  xxl: "96em", // 1536px
  xxxl: "120em", // 1920px
};

export default breakpoints;
